module.exports = __webpack_public_path__ + "img/animals.165ceac0.svg";